import * as freshchatApi from '@/services/rest-api-vsms/lib/freshchat/freshchat'

let WHOAMI, RESTOREID, STORE, VALIDATION, timer

const exludeFreshchatPath = [
  '/404/',
  '/login/',
  '/forgotpassword/',
  '/forgotpassword/result/',
  '/forgotpassword/reset/',
  '/forgotpassword/verification/',
]

async function getRestoreId(whoami) {
  if (!whoami) return
  try {
    const res = await freshchatApi.get(whoami.userId)
    return res.errors ? null : res.data.restore_id
  } catch (error) {
    console.log(error)
  }
}

function saveRestoreId(userId, restoreId) {
  freshchatApi.store({
    user_id: userId,
    restore_id: restoreId,
  })
}

async function setWidgetMessengerConfig() {
  window.fcWidgetMessengerConfig.externalId = WHOAMI?.email
  window.fcWidgetMessengerConfig.restoreId = RESTOREID
  STORE.dispatch('freshchat/setWidgetMessengerConfig', window.fcWidgetMessengerConfig)
}

function validate(data) {
  return (
    data?.identifier === WHOAMI.email &&
    data?.firstName === WHOAMI.name &&
    data?.lastName === WHOAMI.companyName
  )
}

export async function initFreshchat(whoami, store) {
  console.log('init freshchat...')
  let hideChatButton = false
  const freshChatSupportFlag = store.state.identity.featureFlag.find((feature) =>
    feature.key.includes('freshchat_support')
  )
  if (
    !JSON.parse(freshChatSupportFlag.value).custom_button &&
    JSON.parse(freshChatSupportFlag.value).show
  ) {
    exludeFreshchatPath.forEach((path) => {
      if (path.includes(window.location.pathname) && window.location.pathname !== '/') {
        hideChatButton = true
      }
    })
    window.fcWidgetMessengerConfig.config.headerProperty.hideChatButton = hideChatButton
  }
  if (!whoami || !store.getters['identity/hasAccess'](['0e0-base-livechat:read'])) {
    window.fcWidgetMessengerConfig.config.headerProperty.hideChatButton = true
  }
  WHOAMI = whoami
  RESTOREID = RESTOREID ?? (await getRestoreId(whoami))
  STORE = store

  setWidgetMessengerConfig()
  timer = setInterval(() => {
    if (window.fcWidget && window.fcWidget.isLoaded()) {
      clearInterval(timer)
      if (!whoami || !store.getters['identity/hasAccess'](['0e0-base-livechat:read'])) {
        console.log('destroy unflagged freshchat...')
        window.fcWidget.destroy()
        return
      }
      setWidgetMessengerConfig()
      window.fcWidget.setExternalId(whoami.email)
      window.fcWidget.init({
        firstName: whoami.name,
        lastName: whoami.companyName,
        email: whoami.email,
        externalId: whoami.email,
      })

      window.fcWidget.user.get(function (res) {
        VALIDATION = validate(res.data || null)
        const result = res
        const createdStatus = res?.status

        if (createdStatus === 200 && result.data.restoreId && VALIDATION) {
          saveRestoreId(whoami.userId, result.data.restoreId)
        }

        // let status = res && res.status

        /**condition when mismatched fc user with logged in user,
         * possibly because of data cached*/
        // if (createdStatus === 200 && !VALIDATION) {
        //   window.fcWidget.user.clear()
        //   window.fcWidget.setExternalId(whoami.email)
        //   initFreshchat(whoami, store)
        //   return
        // }

        /**handle when failed init */
        // if (createdStatus === 401 && window.fcWidgetMessengerConfig.restoreId !== null) {
        //   window.fcWidget.setExternalId(whoami.email)
        //   window.fcWidget.user.setProperties({
        //     firstName: whoami.name,
        //     lastName: whoami.companyName,
        //     email: whoami.email,
        //   })
        //   initFreshchat(whoami, store)
        //   return
        // }

        /**prepare data for user creation */
        window.fcWidget.user.setProperties({
          firstName: whoami.name,
          lastName: whoami.companyName,
          email: whoami.email,
        })
        window.fcWidget.on('user:created', function (resp) {
          let createdStatus = resp && resp.status,
            result = resp && resp.data
          window.fcWidget.setExternalId(whoami.email)

          if (createdStatus === 200 && result.restoreId) {
            // Update restoreId in your database
            saveRestoreId(whoami.userId, result.restoreId)
          }
        })
      })
    }
  }, 1000)
}

export async function resetFreshchat() {
  if (timer) {
    clearInterval(timer)
    timer = null
  }

  WHOAMI = null
  RESTOREID = null
  VALIDATION = null

  if (window.fcWidgetMessengerConfig) {
    window.fcWidgetMessengerConfig.externalId = null
    window.fcWidgetMessengerConfig.restoreId = null
  }

  if (STORE) {
    STORE.dispatch('freshchat/setWidgetMessengerConfig', window.fcWidgetMessengerConfig)
    STORE = null
  }

  if (window.fcWidget) {
    try {
      await window.fcWidget.user.clear()
      console.log('Freshchat session cleared successfully.')
    } catch (error) {
      console.error('Failed to clear Freshchat user session:', error)
    } finally {
      window.fcWidget.destroy()
    }
  }
}
